import React from 'react';
import HsButton from '../../_common/hs-button/hs-button';
import AccountContext from '../../../context/account/account.context';
import { AdvantagesEntryStoryblok, AdvantagesStoryblok } from '../../../_shared/interfaces/storyblok';
import { navigate } from 'gatsby';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';

import * as HomeAdvantagesStylesHs from './advantages.hs.module.scss';
import * as HomeAdvantagesStylesDr from './advantages.dr.module.scss';
import { getMultilinkURL } from '../../../lib/helpers/helpers';

const HomeAdvantages = ({ blok, storyblokCommon }: { blok: AdvantagesStoryblok; storyblokCommon: StoryblokCommon }) => {
    const accountContext = React.useContext(AccountContext);
    const HomeAdvantagesStyles = storyblokCommon.configuration.content.theme === 'dr' ? HomeAdvantagesStylesDr : HomeAdvantagesStylesHs;

    return (
        <div className={HomeAdvantagesStyles.homeAdvantages}>
            <div>
                <ul>
                    {blok.advantages.map((advantage: AdvantagesEntryStoryblok) => {
                        return (
                            <li key={advantage._uid}>
                                <h4>{advantage.headline}</h4>
                                <p>{advantage.copytext}</p>
                            </li>
                        );
                    })}
                </ul>
                {accountContext.account && (
                    <div className={HomeAdvantagesStyles.buttonWrapper}>
                        <HsButton onClick={() => navigate(getMultilinkURL(blok.link_order))} storyblokCommon={storyblokCommon}>
                            {blok.button_order}
                        </HsButton>
                    </div>
                )}
            </div>

            <div>
                {!accountContext.account ? (
                    <>
                        {blok.small_font_size ? (
                            <>
                                <h4 className={HomeAdvantagesStyles.underscore}>{blok.headline}</h4>
                                <p style={{ marginBottom: '24px' }}>{blok.subheadline}</p>
                            </>
                        ) : (
                            <>
                                <h2 className={HomeAdvantagesStyles.underscore}>{blok.headline}</h2>
                                <h3 style={{ marginBottom: '24px' }}>{blok.subheadline}</h3>
                            </>
                        )}
                        <HsButton
                            onClick={() =>
                                accountContext.signIn(
                                    storyblokCommon.configuration.content.language,
                                    storyblokCommon.configuration.content.theme,
                                )
                            }
                            storyblokCommon={storyblokCommon}
                        >
                            {blok.button_register}
                        </HsButton>
                    </>
                ) : (
                    <>
                        {blok.small_font_size ? (
                            <>
                                <h4 className={HomeAdvantagesStyles.underscore}>{blok.headline_logged_in}</h4>
                                <p style={{ marginBottom: '24px' }}>{blok.subheadline_logged_in}</p>
                            </>
                        ) : (
                            <>
                                <h2 className={HomeAdvantagesStyles.underscore}>{blok.headline_logged_in}</h2>
                                <h3 style={{ marginBottom: '24px' }}>{blok.subheadline_logged_in}</h3>
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default HomeAdvantages;
